import script from "./QRCodeScan.vue?vue&type=script&setup=true&lang=ts"
export * from "./QRCodeScan.vue?vue&type=script&setup=true&lang=ts"

import "./QRCodeScan.vue?vue&type=style&index=0&id=3b64f4cf&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b64f4cf"]])

export default __exports__